module.exports = __webpack_public_path__ + "static/img/clothing_08.8b58c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_08.png
// module id = LriO
// module chunks = 0